import { useModeStore, type AppMode } from '@stores/modeStore.js'
import { markModeExplicit } from '@utils/modePreference.js'

const LABELS: Record<AppMode, string> = {
  guia: 'Guia',
  obra: 'Obra',
}

interface Props {
  variant?: 'default' | 'header'
  className?: string
}

export function ModeToggle({ variant = 'default', className = '' }: Props) {
  const mode = useModeStore((s) => s.mode)
  const setMode = useModeStore((s) => s.setMode)

  const selectMode = (m: AppMode) => {
    markModeExplicit()
    setMode(m)
  }

  return (
    <div
      className={[
        'cf3-mode-toggle',
        variant === 'header' ? 'cf3-mode-toggle--header' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      role='group'
      aria-label='Modo do aplicativo'
    >
      {(['guia', 'obra'] as AppMode[]).map((m) => (
        <button
          key={m}
          type='button'
          className={['cf3-mode-toggle__btn', mode === m ? 'cf3-mode-toggle__btn--active' : '']
            .filter(Boolean)
            .join(' ')}
          aria-pressed={mode === m}
          onClick={() => selectMode(m)}
        >
          {LABELS[m]}
        </button>
      ))}
    </div>
  )
}
